import React from "react"
import NewsList from "../components/news/news-list"
import Services from "../components/other/services"
import TopSlider from "../components/helpers/slider";
import Partners from "../components/other/partners";
import Offers from "../components/other/offers";
import Achievements from "../components/other/achievements";
import ReviewsMain from "../components/other/reviews-main";
import Caption from "../components/helpers/caption";
import MainPageContent from "../components/other/mainPageContent";
import SiteContext from "../context/site-context";


export default function Home() {
   const scrollY = typeof window !== "undefined" ? window.scrollY : null

   const [, setScroll] = React.useState(scrollY)
   const {loadingState} = React.useContext(SiteContext)

   function handleScroll() {
      setScroll(window.scrollY)
   }


   React.useEffect(() => {
      window.addEventListener("scroll", handleScroll)

      return () => {
         window.removeEventListener("scroll", handleScroll)
      }
   }, [])


   return (<>

      {loadingState.menuItemsLoaded === true ?
         (<>
            <TopSlider/>
            <Caption text="Статьи и новости"/>
            {loadingState.mainSliderLoaded === true &&
            <div className="container" style={{minHeight: "390px"}}>
               <NewsList itemsLimit={3} pageType="news"/>
            </div>}
            {loadingState.newsLoaded === true &&
            <>
               <Services/>
               <MainPageContent/>
            </>}
            {loadingState.mainPageLoaded === true &&
            <Achievements/>}
            {loadingState.achievementsLoaded === true &&
            <ReviewsMain/>}
            <Offers/>
            {loadingState.reviewsLoaded === true &&
            <Partners/>}
         </>)
         :
         <Offers/>
      }
   </>)
}
